import { useState } from "react";
import type { StaffOrderDetail } from "@/api/staff";
import { useNavigate } from "react-router-dom";
import InvoiceModal from "@/components/modals/InvoiceModal";

interface Props {
  orderInfo: StaffOrderDetail;
}

const ITEMS = [
  { icon: "ri-file-text-line", iconBg: "#E3F2FD", iconColor: "#1565C0", label: "电子合同", subLabel: "", action: true },
  { icon: "ri-receipt-line", iconBg: "#FFF3E0", iconColor: "#EF6C00", label: "电子发票", subLabel: "", action: true },
  { icon: "ri-customer-service-2-line", iconBg: "#E8F5E9", iconColor: "#2E7D32", label: "在线客服", subLabel: "7×24小时", action: false },
];

export function VoucherServiceSection({ orderInfo }: Props) {
  const navigate = useNavigate();
  const [showInvoice, setShowInvoice] = useState(false);

  const handleContractClick = () => {
    // 电子合同 - 跳转合同页面
    navigate(`/contracts?id=${orderInfo.id}`, { state: { orderId: orderInfo.id } });
  };
  const handleInvoiceClick = () => {
    setShowInvoice(true);
  };
  const handleCustomerServiceClick = () => {
    // 在线客服
    navigate("/workspace/emergency");
  };

  const handlers = [handleContractClick, handleInvoiceClick, handleCustomerServiceClick];

  const invoiceAmount = Number(orderInfo.pay_price || orderInfo.original_price || 0);

  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-sm">
      <div className="px-4 py-3 border-b border-gray-50">
        <span className="text-sm font-bold text-gray-900">凭证与服务</span>
      </div>

      <div className="divide-y divide-gray-50">
        {ITEMS.map((item, i) => (
          <button
            key={item.label}
            onClick={() => handlers[i]()}
            className="w-full flex items-center gap-3 px-4 py-3.5 active:bg-gray-50 text-left"
          >
            <div className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0" style={{ background: item.iconBg }}>
              <i className={`${item.icon} text-base`} style={{ color: item.iconColor }} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-gray-900">{item.label}</p>
              {item.subLabel && <p className="text-xs text-gray-400 mt-0.5">{item.subLabel}</p>}
            </div>
            {item.label === "电子合同" && (
              <span className="text-xs text-blue-500 mr-1"></span>
            )}
            <i className="ri-arrow-right-s-line text-gray-300 text-sm" />
          </button>
        ))}
      </div>

      {showInvoice && (
        <InvoiceModal
          orderId={orderInfo.id ?? 0}
          productType="guide"
          productTitle={orderInfo.item_name || "旅行定制师订单"}
          productSubtitle={`${orderInfo.service_min || orderInfo.num || ""}${orderInfo.unit_name || ""}`}
          invoiceAmount={invoiceAmount}
          onClose={() => setShowInvoice(false)}
        />
      )}
    </div>
  );
}
